module.exports = __webpack_public_path__ + "static/25-a5a7c278da61ddf535c596cd0b10e00c.png";